export const errorCode = 'PE-0010'

export const connectionTypeName = {
  servicenow: 'ServiceNow',
  jira: 'JIRA',
}

export const ticketTypes = {
  issue: 'Issue',
  incident: 'Incident',
  change_request: 'Change Request',
}
